import * as React from 'react';
import {connect} from 'react-redux';
// @ts-expect-error
import {Link as RouterLink, withRouter, ContextRouter} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {Dialog} from 'shells/dialog/dialog';
import {Link} from 'shells/link/link';
import {FooterBar} from 'shells/modal/footer-bar';

import type {Task as TaskFragment} from 'nutshell-graphql-types';

// @ts-expect-error
import {refetchTodo} from '../../master-dashboard/dashboard-actions';

import {CompleteTaskButton} from './complete-task-button';

import styles from '../default-footer/default-footer.module.css';

// Have to specify type for ownProps to satisify flow

// @ts-expect-error
function mapDispatchToProps(dispatch, _ownProps: RoutedProps): DispatchProps {
    return {
        refetchTaskForRedux: (id) => {
            dispatch(refetchTodo(id));
        },
    };
}

type DispatchProps = {
    refetchTaskForRedux: (id: string) => any;
};

type OwnProps = {
    onUpdateTask: () => any;
    onToggleTaskCompletion: (isCompleting: boolean) => any;
    task: TaskFragment;
};

type RoutedProps = ContextRouter & OwnProps;

type Props = RoutedProps & DispatchProps;

export class TaskFooterComponent extends React.PureComponent<
    Props,
    {
        deleteDialog: React.ReactElement<any> | null | undefined;
    }
> {
    deleteButton: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            deleteDialog: undefined,
        };
    }

    render() {
        const isDeleted = Boolean(this.props.task.deletedTime);
        const editLink = this.props.location.pathname.endsWith('/')
            ? `${this.props.location.pathname}edit`
            : `${this.props.location.pathname}/edit`;

        return (
            <div className={styles['task-footer']}>
                <FooterBar
                    left={
                        <div className={styles['delete-btn']}>
                            <ButtonMover size='normal' direction='left'>
                                <Button
                                    variant='text-danger'
                                    // @ts-expect-error
                                    getButtonRef={(node) => {
                                        this.deleteButton = node;
                                    }}
                                    disabled={isDeleted}
                                    onClick={this.handleDelete}
                                >
                                    {isDeleted ? 'This task is deleted.' : 'Delete'}
                                </Button>
                            </ButtonMover>
                        </div>
                    }
                    right={
                        <div className={styles['right-btn-group']}>
                            {isDeleted ? null : (
                                <Link
                                    // @ts-expect-error
                                    as={RouterLink}
                                    variant='button-secondary'
                                    size='big'
                                    to={{
                                        pathname: editLink,
                                        state: {
                                            modal:
                                                this.props.location.state &&
                                                this.props.location.state.modal,
                                        },
                                    }}
                                >
                                    Edit
                                </Link>
                            )}
                            <CompleteTaskButton
                                disabled={isDeleted}
                                isActive={Boolean(this.props.task.completedTime)}
                                onClick={this.handleToggleTaskCompletion}
                            />
                        </div>
                    }
                />
                {this.state.deleteDialog}
            </div>
        );
    }

    handleToggleTaskCompletion = () => {
        const isCompleting = !this.props.task.completedTime;

        const patchArray = [
            {
                op: 'replace',
                path: '/tasks/0/isCompleted',
                value: isCompleting,
            },
        ];

        $.ajax({
            type: 'PATCH',
            url: this.props.task.href,
            contentType: 'application/json-patch+json',
            data: JSON.stringify(patchArray),
        }).then((res) => {
            this.props.onToggleTaskCompletion(isCompleting);

            const task = res && res.tasks && res.tasks[0];
            if (task) {
                this.props.refetchTaskForRedux(task.id);
            }
        });
    };

    handleDelete = () => {
        const options = {
            question: 'Are you sure you want to delete this task?',
            onYes: () => {
                $.ajax({
                    type: 'DELETE',
                    url: this.props.task.href,
                }).then((res) => {
                    this.props.onUpdateTask();

                    const task = res && res.tasks && res.tasks[0];
                    if (task) {
                        this.props.refetchTaskForRedux(task.id);
                    }
                });

                this.setState({deleteDialog: undefined});
            },
            onNo: () => {
                this.setState({deleteDialog: undefined});
            },
        } as const;

        this.setState({
            deleteDialog: (
                <Dialog
                    anchor={this.deleteButton}
                    location='top'
                    isWarning={true}
                    question={options.question}
                    onPrimary={options.onYes}
                    onSecondary={options.onNo}
                />
            ),
        });
    };
}

// @ts-expect-error
const connector = connect<Props, RoutedProps, _, _, _, _>(null, mapDispatchToProps);
// @ts-expect-error
export const TaskFooter = withRouter<OwnProps>(connector(TaskFooterComponent));
